import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { ActionItemDrawerModule } from '@main-client/src/app/members/automated-user-management/action-item-drawer/action-item-drawer.module';
import { AutomatedUserManagementBannerModule } from '@main-client/src/app/members/automated-user-management/banner/banner.module';

import { ActionQueueService } from './action-queue.service';
import { ActionItemDrawerService } from '@main-client/src/app/members/automated-user-management/action-item-drawer/action-item-drawer.service';

import { ActionQueueComponent } from './action-queue.component';

@NgModule({
  declarations: [ActionQueueComponent],
  exports: [ActionQueueComponent],
  imports: [
    ActionItemDrawerModule,
    AutomatedUserManagementBannerModule,
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    NzBreadCrumbModule,
    NzStepsModule,
    NzToolTipModule,
    RouterLink,
  ],
  providers: [ActionItemDrawerService, ActionQueueService, DatePipe],
})
export class ActionQueueModule {}
